module.exports = __webpack_public_path__ + "img/plan-uni2000.svg";